import { withPrefix } from 'gatsby';

export const fonts = `
  @font-face {
    font-family: 'SuisseIntl';
    font-weight: 300;
    font-style: normal;
    src: url(${withPrefix('/fonts/SuisseIntl-Regular.woff2')}) format('woff2');
    font-display: swap;
    font-feature-settings: 'salt' 2;
  }

  @font-face {
    font-family: 'SuisseIntl';
    font-weight: 400;
    font-style: normal;
    src: url(${withPrefix('/fonts/SuisseIntl-Book.woff2')}) format('woff2');
    font-display: swap;
    font-feature-settings: 'salt' 2;
  }

  @font-face {
    font-family: 'SuisseIntl';
    font-weight: 500;
    font-style: normal;
    src: url(${withPrefix('/fonts/SuisseIntl-Medium.woff2')}) format('woff2');
    font-display: swap;
    font-feature-settings: 'salt' 2;
  }

  @font-face {
    font-family: 'SuisseIntl';
    font-weight: 600;
    font-style: normal;
    src: url(${withPrefix('/fonts/SuisseIntl-SemiBold.woff2')}) format('woff2');
    font-display: swap;
    font-feature-settings: 'salt' 2;
  }

  @font-face {
    font-family: 'ryry';
    font-weight: 400;
    font-style: normal;
    src: url(${withPrefix('/fonts/ryry-Regular.woff2')}) format('woff2');
  }

  @font-face {
    font-family: 'SuisseIntlMono';
    font-weight: 400;
    font-style: normal;
    src: url(${withPrefix('/fonts/SuisseIntlMono-Regular.woff2')}) format('woff2');
  }
`;
